// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-button_cd38b476 {
  margin: 0;
  padding: 0;
  border: 0;
}
.icon-button_cd38b476 {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  color: #657682;
}
.icon-button_cd38b476:hover {
  text-decoration: none;
  color: #26649e;
}
.icon-button_cd38b476:active {
  color: #11304d;
}
.icon-button_cd38b476:disabled {
  cursor: default;
  background-color: transparent !important;
  color: #c1c8cd !important;
}
.icon-button_button_cd38b476 {
  color: #1d5080;
  width: 2.667rem;
  min-width: 2.667rem;
  height: 2.667rem;
}
.icon-button_button_cd38b476.icon-button_size-l_cd38b476 {
  width: 2rem;
  min-width: 2rem;
  height: 2rem;
}
.icon-button_button_cd38b476.icon-button_size-xl_cd38b476 {
  width: 2.667rem;
  min-width: 2.667rem;
  height: 2.667rem;
}
.icon-button_button_cd38b476:hover {
  color: #267479;
}
.icon-button_button_cd38b476:hover:not(.icon-button_flat_cd38b476) {
  background-color: #eaedef;
}
.icon-button_button_cd38b476:active {
  color: #1d5080;
}
.icon-button_button_cd38b476:active:not(.icon-button_flat_cd38b476) {
  background-color: #dce1e5;
}
.icon-button_button_cd38b476.icon-button_selected_cd38b476 {
  background-color: #dce1e5;
}
.icon-button_button_cd38b476.icon-button_selected_cd38b476:hover {
  background-color: #dce1e5;
  color: #1d5080;
}
.icon-button_button_cd38b476.icon-button_selected_cd38b476:disabled {
  background-color: #eaedef !important;
  color: #c1c8cd !important;
}
.icon-button_inline_cd38b476 {
  display: inline-flex;
}
.icon-button__hole_cd38b476 {
  display: block;
  position: relative;
  left: 0;
  right: 0;
  margin: auto;
}
.icon-button_with-loader_cd38b476 {
  position: relative;
}
.icon-button_with-loader_cd38b476 .icon-button__hole_cd38b476 > i {
  opacity: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon-button": `icon-button_cd38b476`,
	"icon-button_button": `icon-button_button_cd38b476`,
	"icon-button_size-l": `icon-button_size-l_cd38b476`,
	"icon-button_size-xl": `icon-button_size-xl_cd38b476`,
	"icon-button_flat": `icon-button_flat_cd38b476`,
	"icon-button_selected": `icon-button_selected_cd38b476`,
	"icon-button_inline": `icon-button_inline_cd38b476`,
	"icon-button__hole": `icon-button__hole_cd38b476`,
	"icon-button_with-loader": `icon-button_with-loader_cd38b476`
};
export default ___CSS_LOADER_EXPORT___;
